import Events from '../lib/events.js';
import { t9n } from '../lib/translate.js';
import { TS } from '../config/translation-keys.js';
import APIClient from '../state-charts/api-client';

export default class ClaimMachine {
  constructor(options) {
    this.make_context(options);
    this.add_computed_context();
  }

  make_context(options) {
    this.context = {
      // original context
      ...options.context,

      // static/parent data
      id: options.id,
      main: options.main,
      minimum_amount: options.main.context.pp_minimum,
      multiplier: options.main.context.pp_multiplier,
      currency_sign: options.main.context.currency_sign,
      amount: options.main.context.amount,
      invitation_code: options.main.context.invitation_code,

      // variables
      processing: false,
    };
  }

  add_computed_context() {
    // calculated variables
    this.context.cash_amount = Number(this.context.amount) / this.context.multiplier;

    this.context.amount_text =
        `${this.context.amount} (${this.context.cash_amount} ${this.context.currency_sign})`;

    // translations
    this.context.form_title = t9n(TS.PILOT_POINTS_CLAIM_FORM_TITLE);

    this.context.explanation_1 = t9n(TS.PILOT_POINTS_CLAIM_EXPLANATION_LINE1);

    this.context.explanation_2 = t9n(TS.PILOT_POINTS_CLAIM_EXPLANATION_LINE2);

    this.context.your_pp_label = t9n(TS.PILOT_POINTS_CLAIM_YOUR_PP_LABEL);

    this.context.invitation_code_label = t9n(TS.PILOT_POINTS_CLAIM_INVITATION_CODE_LABEL);

    this.context.claim_label = t9n(TS.PILOT_POINTS_CLAIM_CLAIM_LABEL);

    this.context.processing_text = t9n(TS.PILOT_POINTS_CLAIM_PROCESSING_TEXT);

    this.context.success_text = t9n(TS.PILOT_POINTS_CLAIM_SUCCESS_TEXT);
  }

  update_context(context) {
    this.context = { ...this.context, ...context };
    this.add_computed_context();
  }

  update_amount(amount) {
    Events.dispatch('ppamountchanged', { amount: amount });
  }

  async claim() {
    let data = { invitation_code: this.context.invitation_code };

    this.context.processing = true;
    let response = await APIClient.claim_pilot_points(data);
    this.context.processing = false;

    if (!response) {
      return false;
    }

    this.context.processing = false;
    this.update_context({amount: response.pilot_points});
    this.update_amount(response.pilot_points);

    return true;
  }
}
